import { Chatbox } from '@talkjs/react'
import styled from 'styled-components'

import { Drawer, Layout, SpinnerWheel } from '@loadsmart/miranda-react'

export const DrawerHeader = styled(Drawer.Header)`
  gap: 0;
`

export const DrawerBody = styled(Drawer.Body)`
  height: 100%;
  padding: 0;
  position: relative;
`

export const DrawerWrapper = styled.div`
  top: 0;
  right: 0;
  bottom: 0;
  left: 0;
  position: absolute;
  display: flex;
  flex-direction: column;
`

export const StyledChatBox = styled(Chatbox).attrs({
  theme: 'shippperguide',
})`
  flex-grow: 1;
  overflow: hidden;
`

export const LoadingBox = styled(Layout.Stack)`
  height: 100%;
  justify-content: center;
`

export const LoadingIcon = styled(SpinnerWheel).attrs({
  size: '50px',
})`
  align-self: center;
`
